import type { ParticipantWithDetails } from '@/Services/eventParticipants.service';
import type { StickerPerson } from './stickerLayout';

/** Data one badge sticker needs, from an admin-side participant row */
/** `withPin`: the event has an election, so the badge carries the PIN to vote from the phone */
export function participantToSticker(p: ParticipantWithDetails, withPin = false): StickerPerson {
  const data = (p.registration_data ?? {}) as Record<string, string | undefined>;
  const kind = (data.kind as StickerPerson['kind']) ?? (p.minister_id ? 'MINISTER' : p.guest?.is_delegate ? 'DELEGATE' : 'GUEST');
  return {
    token: p.public_token,
    full_name: p.minister?.full_name ?? p.guest?.full_name ?? '',
    dni: data.dni ?? p.minister?.dni ?? p.guest?.dni ?? null,
    adb_code: p.minister?.adb_code ?? null,
    district: p.minister?.district?.name ?? null,
    region: p.minister?.region?.name ?? null,
    kind,
    voting_pin: withPin ? p.voting_pin : null,
  };
}
